import { setupWorker } from 'msw/browser';

import { handlers } from '@/mocks/handlers';

// Configures the Service Worker (to mock API requests during development)
export const worker = setupWorker(...handlers);
